<script setup lang="ts">
import { TheAlertDisplayer, TheDialogDisplayer } from "@debitroom-software/vuetify-alert";
import { TheSnackbarQueue } from "@debitroom-software/vuetify-snackbar-queue";
import { useRoute, useRouter } from "vue-router";

import { useAuthorisationStore } from "@/modules/authorisation/authorisationStore";

const router = useRouter();
const route = useRoute();
const authorisationStore = useAuthorisationStore();

router.isReady().then(() => {
  if (!authorisationStore.redirectToAfterLoginUrl) {
    authorisationStore.redirectToAfterLoginUrl = route.fullPath;
  }
});
</script>

<template>
  <router-view />
  <TheSnackbarQueue />
  <TheAlertDisplayer />
  <TheDialogDisplayer />
</template>
